"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeCreationSet = void 0;
const immutable_1 = require("immutable");
const CreationSet_1 = require("../entity/CreationSet");
const creation_1 = require("./creation");
const creativeFormat_1 = require("./creativeFormat");
const createSomeCreationSet = ({ id = '12345', creativeFormats = immutable_1.List.of(creativeFormat_1.createSomeCreativeFormat({
    id: '50',
}), creativeFormat_1.createSomeCreativeFormat({
    id: '51',
}), creativeFormat_1.createSomeCreativeFormat({
    id: '52',
})), creations = immutable_1.List.of(creation_1.createSomeCreation({
    id: '123',
}), creation_1.createSomeCreation({
    id: '124',
}), creation_1.createSomeCreation({
    id: '125',
})), creationsByOptimizerId = immutable_1.List.of(creation_1.createSomeCreation({
    id: '123',
})), creationsByOtherAssignedOptimizers = immutable_1.List.of(creation_1.createSomeCreation({
    id: '321',
})), amount = 3, deliveryDueDate = undefined, screeningDueDate = undefined, deliveryDueDays = 5, expressDueDays = 2, } = {}) => new CreationSet_1.default({
    id,
    creativeFormats,
    creations,
    creationsByOptimizerId,
    creationsByOtherAssignedOptimizers,
    amount,
    deliveryDueDate,
    screeningDueDate,
    deliveryDueDays,
    expressDueDays,
});
exports.createSomeCreationSet = createSomeCreationSet;
